<app-nav></app-nav>
<section class="launchOffer" *ngIf="enrollmentDetails && !claimIntimateSuccess && !claimIntimateFailure">
  <div class="container">
    <div class="col">
      <!-- <h4 class="form-title">Enrollment Details</h4> -->
      <form name="form" #launchOffer="ngForm">


        <!-- abcd -->
        <!-- <form name="form" (ngSubmit)="personalForm.form.valid" #personalForm="ngForm"> -->
        <div class="">
          <!-- Nav pills -->
          <ul class="nav nav-pills justify-content-center" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="pill" href="#details"
                [ngClass]="{ 'active':activeTab==='details'}" (click)="details('details')">Proposer's Details</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#insured" [ngClass]="{ 'active':activeTab==='insured'}"
                data-toggle="tab" (click)="insured('insured')">Insured Details</a>
            </li>
          </ul>

          <!-- Tab panes -->
          <div class="tab-content">

            <div id="details" class="container tab-pane active" [ngClass]="{ 'active':activeTab==='details'}"><br>

              <div class="row">
                <!--  -->
                <div class="col-2" style="padding-right:0px;">
                  <p class="title mendate">Title</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <select class="form-control" name="title" [(ngModel)]="f.title" id="title" #title="ngModel"
                        required>
                        <option value="Mr">Mr</option>
                        <option value="Mr">Mrs.</option>
                        <option value="Ms">Ms</option>
                      </select>
                      <div *ngIf="title.invalid && title.touched " class="error-message">
                        <div *ngIf="title.errors.required">
                          Title is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendate">First Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="fName" [(ngModel)]="f.firstName" id="fName"
                        #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" value="{{firstName}}" required>
                        <div *ngIf="fName.invalid && fName.touched " class="error-message">
                          <div *ngIf="fName.errors.required">
                            First Name is required.
                          </div>
                          <div *ngIf="fName.errors.pattern">
                            Please enter valid First name.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendate">Last Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="lName" [(ngModel)]="f.lastName" id="lName"
                        #lName="ngModel" pattern="[a-zA-Z]+" maxlength="200" value="{{lastName}}" required>
                        <div *ngIf="lName.invalid && lName.touched " class="error-message">
                          <div *ngIf="lName.errors.required">
                            Last Name is required.
                          </div>
                          <div *ngIf="lName.errors.pattern">
                            Please enter valid Last name.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-6">
                  <p class="title mendate">Mobile No.</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control"
                        placeholder="Mobile No." [(ngModel)]="f.mobileNumber" #mobile1="ngModel" maxlength="10"
                        minlength="10" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                        value="{{mobileNumber}}" inputmode="numeric" required disabled>
                        <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                          <div *ngIf="mobile.errors.required">
                            Mobile number is required.
                          </div>
                          <div *ngIf="mobile.errors.maxlength">
                            Mobile number should not be greater than 10 digits.
                          </div>
                          <div *ngIf="mobile.errors.minlength">
                            Mobile number must be at least 10 digits long.
                          </div>
                          <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                            Invalid mobile number.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <p class="title mendate">DOB</p>
                  <div class="sum-insured-input reg-date-input proposal-date-input">
                    <div class="input-group">
                      <div class="input-group addon">
                        <img
                          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                        <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="f.dob"
                          dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2020"
                          placeholder="Date" name="dob" [maxDate]="maxDateValue" (onClose)="checkDOBvalue(); calculateAge();" keepInvalid
                          [required]="true"></p-calendar>
                        <span class="input-group-addon" id="basic-addon-dueDate"></span>
                      </div>
                    </div>
                    <div *ngIf="shouldBe18" class="error-message">
                      Date of birth should be greater than 18.
                    </div>
                    <div *ngIf="DOBrequired" class="error-message">
                      Date of Birth is required.
                    </div>
                  </div>
                </div>
              </div>
             
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">E-mail Address</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="email" name="email" id="email" #email="ngModel"
                        [(ngModel)]="f.email" [email]="true" maxlength="100" value="email" required disabled>
                        <div *ngIf="email.invalid && email.touched " class="error-message">
                          <div *ngIf="email.errors.required">
                            Email Address is required.
                          </div>
                          <div *ngIf="email.errors.email">
                            Please enter correct Email address.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
             
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">PAN Card</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" id="pan" name="pan" #pan="ngModel" [(ngModel)]="f.panNumber"
                        pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}" maxlength="10" required>
                        <div *ngIf="pan.invalid && pan.touched " class="error-message">
                          <div *ngIf="pan.errors.pattern">
                            Please enter valid PAN number.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <p class="title mendate">Pin Code</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="number" name="pinCode" [(ngModel)]="f.pinCode"
                        (keydown.space)="$event.preventDefault();" (keypress)="keyPress($event)"
                        (focusout)="getCityStateList(f.pinCode)" maxlength="6" minlength="6" id="pinCode"
                        #pinCode="ngModel"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        required>
                      <div *ngIf="invalidPincode" class="error-message">
                        Invalid pincode.
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-6">
                  <p class="title mendate">City</p>
                  <div class="sum-insured-input">
                    <select name="city" class="form-control quote-dropdown" id="city" name="city"
                      [(ngModel)]="f.city" #city="ngModel" required>
                      <option *ngFor="let city of cityList" value="{{city}}">{{city | uppercase}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">State</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="stateList" [(ngModel)]="f.state"
                        value="{{stateList}}" disabled>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Address Line-1</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="address1" [(ngModel)]="f.address1" id="address1"
                        #address1="ngModel" maxlength="500" required>
                        <div *ngIf="address1.invalid && address1.touched" class="error-message">
                          <div *ngIf="address1.errors.required">
                            Address is required.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Address Line-2</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="address2" [(ngModel)]="f.address2" id="address2"
                        #address1="ngModel" maxlength="500" required>
                    </div>
                  </div>
                </div>
              </div>
            
              <div class="row mt-4">
                
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-bordered-blue" (click)="details('insured')">Next</button>
                </div> -->
                <div class="col-12 text-center">
                  <button class="btn btn-bordered-blue" (click)="details('insured')">Next</button>
                </div>
              </div>
            </div>
            <div id="insured" class="container tab-pane vehicle-section" [ngClass]="{ 'active':activeTab==='insured'}">
              <br>
              <div class="row">
                <div class="col-10">
                  <p class="">Insured details are same as above</p>
                </div>
                <div class="col-2">
                  <label class="switch">
                    <input type="checkbox" id="click" (click)="getSameDetailsData()">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Relation</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <!-- <input class="form-control" type="text" name="relation" [(ngModel)]="f.relation"
                        id="relation" #relation="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required> -->
                      <!-- <select class="form-control" id="nomineeRelation" name="nomineeRelation" [(ngModel)]="launch.nomineeRelation" id="nomineeRelation" #nomineeRelation="ngModel" required>
                        <option value="" selected="selected" disabled="">Nominee Relation</option>
                        <option  *ngFor="let list of nomineeList" value="{{list}}" >{{list}}</option>
                      </select> -->
                      <select _ngcontent-qwe-c1="" class="form-control ng-untouched ng-pristine ng-invalid" 
                      name="relation" [(ngModel)]="f.relation" id="relation" #relation="ngModel" required="">
                        <option _ngcontent-qwe-c1="" disabled="" selected="selected" value="">Relation</option>
                        <option _ngcontent-qwe-c1="" value="SELF" class="ng-star-inserted">SELF</option>
                        <option _ngcontent-qwe-c1="" value="BROTHER" class="ng-star-inserted">BROTHER</option>
                        <option _ngcontent-qwe-c1="" value="FATHER" class="ng-star-inserted">FATHER</option>
                        <option _ngcontent-qwe-c1="" value="GRAND FATHER" class="ng-star-inserted">GRAND FATHER</option>
                        <option _ngcontent-qwe-c1="" value="GRAND MOTHER" class="ng-star-inserted">GRAND MOTHER</option>
                        <option _ngcontent-qwe-c1="" value="BROTHER IN LAW" class="ng-star-inserted">BROTHER IN LAW</option>
                        <option _ngcontent-qwe-c1="" value="MOTHER IN LAW" class="ng-star-inserted">MOTHER IN LAW</option>
                        <option _ngcontent-qwe-c1="" value="SISTER IN LAW" class="ng-star-inserted">SISTER IN LAW</option>
                        <option _ngcontent-qwe-c1="" value="MOTHER" class="ng-star-inserted">MOTHER</option>
                        <option _ngcontent-qwe-c1="" value="SISTER" class="ng-star-inserted">SISTER</option>
                        <option _ngcontent-qwe-c1="" value="SON" class="ng-star-inserted">SON</option>
                        <option _ngcontent-qwe-c1="" value="DAUGHTER" class="ng-star-inserted">DAUGHTER</option>
                        <option _ngcontent-qwe-c1="" value="WIFE" class="ng-star-inserted">WIFE</option>
                        <option _ngcontent-qwe-c1="" value="HUSBAND" class="ng-star-inserted">HUSBAND</option></select>
                      <div *ngIf="relation.invalid && relation.touched" class="error-message">
                        <div *ngIf="relation.errors.required">
                          Relation is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <!--  -->
                <div class="col-2" style="padding-right:0px;">
                  <p class="title mendate">Title</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <select class="form-control" name="title" [(ngModel)]="f.insuredTitle" id="insuredTitle" #insuredTitle="ngModel"
                        required>
                        <option value="Mr">Mr</option>
                        <option value="Mr">Mrs.</option>
                        <option value="Ms">Ms</option>
                      </select>
                      <div *ngIf="insuredTitle.invalid && insuredTitle.touched " class="error-message">
                        <div *ngIf="insuredTitle.errors.required">
                          Title is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendate">First Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="fName" [(ngModel)]="f.insuredFirstName" id="insuredFName"
                        #insuredFName="ngModel" pattern="[a-zA-Z]+" maxlength="200" value="{{firstName}}" required>
                        <div *ngIf="insuredFName.invalid && insuredFName.touched " class="error-message">
                          <div *ngIf="insuredFName.errors.required">
                            First Name is required.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <p class="title mendate">Last Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="lName" [(ngModel)]="f.insuredLastName" id="insuredLName"
                        #insuredLName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                        <div *ngIf="insuredLName.invalid && insuredLName.touched " class="error-message">
                          <div *ngIf="insuredLName.errors.required">
                            Last Name is required.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Date of Birth</p>
                  <div class="sum-insured-input reg-date-input proposal-date-input">
                    <div class="input-group">
                      <div class="input-group addon">
                        <img
                          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                        <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="f.insuredDob"
                          dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2020"
                          placeholder="Date" name="dob" [maxDate]="maxDateValue" (onClose)="checkDOBvalue()" keepInvalid
                          [required]="true"></p-calendar>
                        <span class="input-group-addon" id="basic-addon-dueDate"></span>
                      </div>
                    </div>
                    <div *ngIf="shouldBe18" class="error-message">
                      Insured Date of birth should be greater than 18.
                    </div>
                    <div *ngIf="DOBrequired" class="error-message">
                      Insured Date of Birth is required.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Occupation</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <!-- <input class="form-control" type="text" name="occupation" [(ngModel)]="f.occupation" id="occupation"
                  #occupation="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required> -->
                      <select class="form-control long-text" id="insuredOccupation" name="occupation"
                        [(ngModel)]="f.occupation" id="occupation" #occupation="ngModel" required>
                        <option *ngFor="let list of listOfOccupation" value="{{list.value}}">{{list.value | uppercase}}
                        </option>
                      </select>
                      <div *ngIf="occupation.invalid && occupation.touched " class="error-message">
                        <div *ngIf="occupation.errors.required">
                          Occupation is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Nominee Name</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <input class="form-control" type="text" name="nomineeName" [(ngModel)]="f.nomineeName"
                        id="nomineeName" #nomineeName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                        <div *ngIf="nomineeName.invalid && nomineeName.touched " class="error-message">
                          <div *ngIf="nomineeName.errors.required">
                            Nominee Name is required.
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="title mendate">Nominee Relation</p>
                  <div class="sum-insured-input">
                    <div class="form-group">
                      <!-- <input class="form-control" type="text" name="nomineeRelation"
                        [(ngModel)]="f.nomineeRelation" id="nomineeRelation" #nomineeRelation="ngModel"
                        pattern="[a-zA-Z\s]+" maxlength="200" required> -->
                      <select class="form-control" id="nomineeRelation" name="nomineeRelation" [(ngModel)]="f.nomineeRelation" id="nomineeRelation" #nomineeRelation="ngModel" required>
                        <option value="" selected="selected" disabled="">Nominee Relation</option>
                        <option  *ngFor="let list of nomineeList" value="{{list}}" >{{list}}</option>
                      </select>
                      <div *ngIf="nomineeRelation.invalid && nomineeRelation.touched " class="error-message">
                        <div *ngIf="nomineeRelation.errors.required">
                          Nominee Relation is required.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row mt-5">
                <div class="col-6 text-right">
                  <button class="btn btn-bordered-blue" (click)="saveProposalGodigit();">Save</button>
                </div>
                <div class="col-6">
                  <button type="button" class="btn btn-bordered-blue"
                    (click)="openModal(template);calculatePremium('godigit');"
                    [disabled]="personalForm.form.invalid">Submit</button>
                </div>
              </div> -->
              <div class="row mt-4">
               
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-bordered-blue" (click)="openModal(template);"
                    [disabled]="launchOffer.form.invalid">Submit</button>
                </div> -->
                <div class="col-12 text-center">
                  <button class="btn btn-bordered-blue" (click)="openModal(template);" 
                  [disabled]="launchOffer.form.invalid" >Submit</button>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
        <span id="snackbar"></span>
        <!-- </form> -->
        <!-- abcd -->

        <!-- <div class="checkbox">
          <input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
            #termCheck="ngModel" value="true" [checked]="true" required> <a (click)="openModal(template);">Terms &
            Conditions*</a>
        </div> -->

        <div class="row mt-4">
          <!-- <div class="col-6">
            <button class="btn btn-bordered-blue pull-left">Save</button>
          </div> -->
          <!-- <div class="col-6 text-right">
            <button class="btn btn-bordered-blue" (click)="openModal(template)">Proceed</button>
          </div> -->
          
        </div>
      </form>
    </div>
  </div>
  <!-- <ng-template #template>
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body">
        <div class="col">
          <h4 class="modal-title">Term & Conditions</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col mt-4">
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://pamstaging.securenow.in/blog/terms-and-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox" *ngIf="environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://securenow.in/blog/terms-and-conditions/" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck5" name="termCheck5" [(ngModel)]="f.termCheck5"
                #termCheck2="ngModel" required> I confirm my current annual income justifies the condition of the
              maximum sum assured according to policy.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2" [(ngModel)]="f.termCheck2"
                #termCheck2="ngModel"> I here by agree to receive service SMS and email alerts</label>
          </div>
          <div class="checkbox" *ngIf="!environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3"
                #termCheck3="ngModel"> I would also like to add Standing instruction on my credit card for
              (paying)automatic future renewal premiums. <a
                href="https://pamstaging.securenow.in/blog/terms-and-conditions" target="_blank">Terms &amp;
                Conditions.</a></label>
          </div>
          <div class="checkbox" *ngIf="environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3"
                #termCheck3="ngModel"> I would also like to add Standing instruction on my credit card for
              (paying)automatic future renewal premiums. <a href="https://securenow.in/blog/terms-and-conditions/"
                target="_blank">Terms &amp; Conditions.</a></label>
          </div>
          <div class="checkbox">
            <label style="line-height: 1.5;"><input type="checkbox" name="termCheck" id="termCheck4" name="termCheck4"
                [(ngModel)]="f.termCheck4" #termCheck4="ngModel" required> I hereby declare
              that no proposed member is involved in any hazardous activity or occupation requiring significant manual
              labour, operating heavy machinery, handling hazardous material, working at
              heights/underground/construction
              sites/oil rigging, near high voltage, high temperature, working in aircrafts or sea-going vessels, armed
              forces or participating in adventure sports/activities. </label>
          </div>
           <div class="col-6 text-right">
            <button class="btn btn-bordered-blue" id="proceedPayment" [disabled]="f.form.invalid" (click)="submitLaunchOffer()">Proceed</button>
          </div>
        </div>
      </div>
    </form>
  </ng-template> -->
  <ng-template #template>
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
    <div class="modal-body">
      <div class="col">
        <h4 class="modal-title">Terms & Conditions</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
            </button>
      </div>
      <div class="col mt-4">
        <div class="checkbox" *ngIf="!environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck" #termCheck="ngModel" required> I hereby agree to the <a
              href="https://pamstaging2.securenow.in/terms-conditions" target="_blank">terms &amp;
              conditions</a> of the purchase of this policy.</label>
        </div>
        <div class="checkbox" *ngIf="environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck" #termCheck="ngModel" required> I hereby agree to the <a
              href="https://securenow.in/terms-conditions" target="_blank">terms &amp;
              conditions</a> of the purchase of this policy.</label>
        </div>
        <div class="checkbox">
          <label><input type="checkbox" name="termCheck" id="termCheck5" name="termCheck5" [(ngModel)]="f.termCheck5" #termCheck2="ngModel" required>  I confirm my current annual income justifies the condition of the maximum sum assured according to policy.</label>
        </div>
        <div class="checkbox">
          <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2" [(ngModel)]="f.termCheck2" #termCheck2="ngModel"> I here by agree to receive service SMS and email alerts</label>
        </div>
        <div class="checkbox" *ngIf="!environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3" #termCheck3="ngModel"> I would also like to add Standing instruction on my credit card for
            (paying)automatic future renewal premiums. <a href="https://pamstaging.securenow.in/blog/terms-and-conditions"
              target="_blank">Terms &amp; Conditions.</a></label>
        </div>
        <div class="checkbox" *ngIf="environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3" #termCheck3="ngModel"> I would also like to add Standing instruction on my credit card for
            (paying)automatic future renewal premiums. <a href="https://securenow.in/blog/terms-and-conditions/"
              target="_blank">Terms &amp; Conditions.</a></label>
        </div>
        <div class="checkbox">
          <label style="line-height: 1.5;"><input type="checkbox" name="termCheck" id="termCheck4" name="termCheck4" [(ngModel)]="f.termCheck4" #termCheck4="ngModel" required> I hereby declare
            that no proposed member is involved in any hazardous activity or occupation requiring significant manual
            labour, operating heavy machinery, handling hazardous material, working at heights/underground/construction
            sites/oil rigging, near high voltage, high temperature, working in aircrafts or sea-going vessels, armed
            forces or participating in adventure sports/activities. </label>
        </div>
      </div>

      <div class="col-6 text-right">
        <button class="btn btn-bordered-blue" id="proceedPayment" [disabled]="f.form.invalid" (click)="submitLaunchOffer()">Proceed</button>
      </div>
    </div>
    </form>
  </ng-template>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="intimate-successfull" *ngIf="claimIntimateSuccess">
  <div class="container">
    <div class="col text-center">
      <h2 class="done-heading">Successfully Done</h2>
      <img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
    </div>
    <center class="sub-title mt-2">
      <p>THANK YOU</p>
    </center>
    <!-- <div class="col note text-center">
          <p>We have recieved your intimation requests for policy no. <span class="policyNo">KKL27889</span>.You'll recieve an email from us for further processes, regarding claim form and required document submission.</p>
      </div> -->
    <div class="col footer-strip text-center">
      <p>For any queries, please reach us at:</p>
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Securenow">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
<section class="intimate-successfull" *ngIf="claimIntimateFailure">
  <div class="container">
    <div class="col text-center">
      <h2 class="done-heading" *ngIf="enrollmentDetails">Fail</h2>
      <h2 class="done-heading" *ngIf="!enrollmentDetails">Oops..!!</h2>
      <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg">
    </div>
    <center class="sub-title mt-2">
      <p>Error</p>
    </center>
    <div class="col note text-center" *ngIf="enrollmentDetails">
      <p class="error">{{error}}</p>
    </div>
    <div class="col note text-center" *ngIf="!enrollmentDetails">
      <p class="error">Sorry.. You have already enrolled for this offer.</p>
    </div>
    <div class="col footer-strip text-center">
      <p>For any queries, please reach us at:</p>
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Securenow">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
